export const experienceData = [
    {
        id: 3,
        company: 'Tech Hive',
        jobtitle: 'Full-Stack Developer',
        startYear: 'April - 2023',
        endYear: 'Present'
    },
    {
        id: 1,
        company: 'Microverse',
        jobtitle: 'Monitor',
        startYear: '2022',
        endYear: 'April - 2023'
    },
    {
        id: 2,
        company: 'Freelancer',
        jobtitle: 'Full-Stack Developer',
        startYear: '2021',
        endYear: '2022'
    },
]
